import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import { RESERVATION_LIST_BY_C_IN_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_QUERY } from "../schema";

type Props = {
	queryVariables?: {
		hotelID: string;
		from: string;
		to: string;
	};
};

export const useReservationListByCInDateQuery = ({ queryVariables }: Props) => {
	const { data } = useCustomSuspenseQuery(
		RESERVATION_LIST_BY_C_IN_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_QUERY,
		queryVariables ? { variables: queryVariables } : undefined,
		queryVariables === undefined, // skipToken = true
	);

	const { queryData } = Converter.useReservationListByCInDateQueryData({ serverData: data });

	return {
		queryData,
	};
};
